import { useEffect, useRef, useState } from "react"

// TODO: drop this fake latency when publish and clear week call the real API.
const MOCK_ACTION_DELAY_MS = 600

/** Runs a mock-latency action behind the table loading bar and click shield, like a real API call. */
export function useMockActionLoading() {
    const [isBusy, setBusy] = useState(false)

    const timerRef = useRef<number | null>(null)
    useEffect(
        () => () => {
            if (timerRef.current !== null) window.clearTimeout(timerRef.current)
        },
        [],
    )

    const runWithLoading = (action: () => void) => {
        if (timerRef.current !== null) window.clearTimeout(timerRef.current)
        setBusy(true)
        timerRef.current = window.setTimeout(() => {
            timerRef.current = null
            setBusy(false)
            action()
        }, MOCK_ACTION_DELAY_MS)
    }

    return { isBusy, runWithLoading }
}
